import { css } from "@microsoft/fast-element";
import { fillColor, focusStrokeOuter, foregroundOnPrimaryActive, neutralForegroundRest, neutralStrokeHover, neutralStrokeRest, getToken } from "../../design-tokens";
import { display } from "../../foundation/display";

/**
 * Styles for Switch
 * @public
 */
export const switchStyles = css`
    ${display("inline-flex")} :host {
        align-items: center;
        outline: none;
        font-family: ${getToken('typography-font-family')};
        margin: calc(${getToken('space-design-unit')} * 1px) 0;
        user-select: none;
    }

    .switch {
        position: relative;
        outline: none;
        box-sizing: border-box;
        width: calc(${getToken('space-design-unit')} * 11px);
        height: calc((${getToken('space-design-unit')}) * 5px);
        background: ${neutralStrokeRest};
        border-radius: 30px;
        border: none;
    }

    .switch:hover {
        background: ${neutralStrokeHover};
        cursor: pointer;
    }

    .switch:active {
        background: ${getToken('color-primary-active')};
    }

    :host(:focus-visible) .switch {
        box-shadow: 0 0 0 2px ${fillColor}, 0 0 0 4px ${focusStrokeOuter};
    }

    .checked-indicator {
        position: absolute;
        top: -5px;
        left: 0px;
        right: calc(${getToken('space-design-unit')} * 5px);
        height: calc((${getToken('space-design-unit')}) * 7px);
        width: calc((${getToken('space-design-unit')}) * 7px);
        background: ${getToken('color-neutral-base')};
        border: calc(${getToken('space-stroke-width')} * 1px) solid ${neutralStrokeRest};
        border-radius: 100%;
        transition: all 0.2s ease-in-out;
    }

    .label {
        color: ${neutralForegroundRest};
        margin-inline-end: calc(${getToken('space-design-unit')} * 1px + 1px);
        font-size: ${getToken('typography-control-font-size')};
        line-height: ${getToken('typography-control-line-height')};
        cursor: pointer;
    }

    :host([aria-checked="true"]) .checked-indicator {
        background: ${getToken('color-primary-base')};
        border-color: ${getToken('color-primary-base')};
        left: calc(${getToken('space-design-unit')} * 5px);
        right: 0px;
    }

    :host([aria-checked="true"]) .switch {
        background: ${getToken('color-primary-active')};
    }

    :host([aria-checked="true"] .switch:hover {
        background: ${getToken('color-primary-hover')};
    }

    :host([aria-checked="true"] .switch:hover .checked-indicator {
        background: ${getToken('color-primary-hover')};
    }

    .checked-indicator {
        background: ${getToken('color-primary-base')};
    }

    :host([aria-checked="true"] .switch:active {
        background: ${getToken('color-primary-active')};
    }

    :host([aria-checked="true"] .switch:active .checked-indicator {
        background: ${foregroundOnPrimaryActive};
    }

    :host([aria-checked="true"]:focus-visible .switch {
        box-shadow: 0 0 0 2px ${fillColor}, 0 0 0 4px ${focusStrokeOuter};
    }

    :host([aria-checked="true"]:focus-visible:not([disabled])) .switch {
        box-shadow: 0 0 0 2px ${fillColor}, 0 0 0 4px ${focusStrokeOuter};
    }
`;
